// enrolledStudentsReducer.js

import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { fetchEnrolledStudents } from "./actionCreator";

export const enrolledStudentsSlice = createSlice({
  name: "enrolledStudents",
  initialState,
  reducers:  {
    setPaginationModel(state, action) {
      state.page = action.payload.page;
      state.limit = action.payload.pageSize;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEnrolledStudents.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchEnrolledStudents.fulfilled, (state, action) => {
      console.log("action action", action.payload.payload.studentList.total);
      state.isLoading = false;
      state.data = action.payload.payload.studentList
      state.error = null;
      state.total = action.payload.payload.studentList.total;
    });
    builder.addCase(fetchEnrolledStudents.rejected, (state, action) => {
      state.isLoading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});


export const { setPaginationModel } = enrolledStudentsSlice.actions;
export default enrolledStudentsSlice.reducer;
